import { CheckBox, TextField } from '@nv/basic-components'
import { SearchAddress } from '@nv/components'
import { useConfigurationContext } from '@nv/contexts'
import { useTranslation } from 'react-i18next'

export const MailingAddressInput = ({
  formik,
  styles,
  addressFieldName = 'mailingAddress',
  searchAddressFieldName = 'searchMailingAddress',
  addressNotListedFieldName = 'mailingAddressNotListed',
  autocomplete = null,
}) => {
  const { t } = useTranslation()
  const { enableManualEntryAddress, enableSingleFieldMailingAddress } = useConfigurationContext()
  return (
    <>
      {enableSingleFieldMailingAddress ? (
        <div className={styles['form__address']}>
          {/* todo */}
          <TextField
            formik={formik}
            type='text'
            field={`${searchAddressFieldName}.formattedAddress`}
            placeholder={t('form.labels.mailingAddress')}
            label={t('form.labels.mailingAddress')}
            isRequired={enableSingleFieldMailingAddress}
            autocomplete={autocomplete}
          />
        </div>
      ) : (
        !formik.values[addressNotListedFieldName] && (
          <div className={styles['form__address']}>
            <SearchAddress objFieldName={searchAddressFieldName} formik={formik} />
            <TextField
              formik={formik}
              type='text'
              field={`${searchAddressFieldName}.unitNumberPOBox`}
              placeholder={t('form.labels.unitNumber')}
              label={t('form.labels.unitNumberAndPO')}
              isRequired={false}
              autocomplete={autocomplete}
            />
          </div>
        )
      )}
      {formik.values[addressNotListedFieldName] && (
        <>
          <div className={styles['form__address']}>
            <TextField
              formik={formik}
              type='text'
              field={`${addressFieldName}.streetAddress`}
              placeholder={t('form.labels.streetAddress')}
              label={t('form.labels.streetAddress')}
              autocomplete={autocomplete}
            />

            <TextField
              formik={formik}
              type='text'
              field={`${addressFieldName}.unitNumberPOBox`}
              placeholder={t('form.labels.unitNumber')}
              label={t('form.labels.unitNumber')}
              isRequired={false}
              autocomplete={autocomplete}
            />
          </div>
          <div className={styles['form__address']}>
            <TextField
              formik={formik}
              type='text'
              field={`${addressFieldName}.city`}
              placeholder={t('form.labels.city')}
              label={t('form.labels.city')}
              autocomplete={autocomplete}
            />
            <TextField
              formik={formik}
              type='text'
              field={`${addressFieldName}.postalCode`}
              placeholder={t('form.labels.postalCode')}
              label={t('form.labels.postalCode')}
              autocomplete={autocomplete}
            />
            <TextField
              formik={formik}
              type='text'
              field={`${addressFieldName}.province`}
              placeholder={t('form.labels.province-state')}
              label={t('form.labels.province-state')}
              autocomplete={autocomplete}
            />

            <TextField
              formik={formik}
              type='text'
              field={`${addressFieldName}.country`}
              placeholder={t('form.labels.country')}
              label={t('form.labels.country')}
              autocomplete={autocomplete}
            />
          </div>
        </>
      )}
      {enableManualEntryAddress ? (
        <CheckBox
          formik={formik}
          field={addressNotListedFieldName}
          checked={formik.values[addressNotListedFieldName]}
          onChange={() => formik.setFieldValue(addressNotListedFieldName, !formik.values[addressNotListedFieldName])}
          label={t('registration.mailingAddressNotListed')}
          ariaLabel={t('registration.mailingAddressNotListed')}
          square={true}
        />
      ) : !enableSingleFieldMailingAddress ? (
        <span style={{ fontStyle: 'italic' }}>{t('registration.form.errors.missingMailingAddress')}</span>
      ) : null}
    </>
  )
}
